import axiosClient from "utils/api";
const URI = "/admin/chat";

export const getChatList = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/inbox/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get chat:", error);
    throw error;
  }
};

export const getChatDetails = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get chat details:", error);
    throw error;
  }
};

export const getChatReport = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/reports/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get chat reports:", error);
    throw error;
  }
};

export const getRequests = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/requests/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get Request:", error);
    throw error;
  }
};

export const getStories = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/story/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get Stories:", error);
    throw error;
  }
};
